import { Shield, Landmark, Building2 } from "lucide-react";

export const CONTACT = {
  company: "VMF Versicherungsmakler Frankfurt",
  legalName: "Xhevdet Rashica – VMF Versicherungsmakler Frankfurt",
  street: "Heddernheimer Landstraße 151",
  city: "60439 Frankfurt am Main",
  phone: "069 83040769",
  phoneHref: "+496983040769",
  email: "info@vm-ffm.de",
  hours: "Mo–Fr 09:00–18:00 Uhr",
};

export const AREAS = [
  {
    key: "versicherung",
    slug: "versicherungen",
    ogImage: "https://static.prod-images.emergentagent.com/jobs/9cdaf805-ebb2-4698-b869-6dae56934adb/images/04c1853c2b1e44df68856a617fca2359030aa7ae443be26d8b556c5323e8535e.jpeg",
    icon: Shield,
    title: "Versicherungen",
    kicker: "Absicherung",
    tagline: "Unabhängiger Schutz für jede Lebenslage.",
    keywords: "Versicherungsmakler Frankfurt, Berufsunfähigkeit, Haftpflicht, Gewerbeversicherung, Krankenversicherung, Altersvorsorge, Rechtsschutz, Wohngebäudeversicherung, Private Krankenvollversicherung",
    intro:
      "Als unabhängiger Makler sind wir keiner Gesellschaft verpflichtet – nur Ihnen. Wir vergleichen hunderte Tarife am Markt und entwickeln ein Absicherungskonzept, das exakt zu Ihrer Lebenssituation passt: transparent, fair und ohne Verkaufsdruck.",
    services: [
      { title: "Private Vorsorge", desc: "Private Krankenvollversicherung, Berufsunfähigkeit und Altersvorsorge – individuell auf Ihre Ziele abgestimmt." },
      { title: "Sachversicherungen", desc: "Wohngebäude, Hausrat, Haftpflicht und Kfz zu geprüften Top-Konditionen." },
      { title: "Rechtsschutz", desc: "Privater, beruflicher und Verkehrs-Rechtsschutz – damit Sie im Streitfall abgesichert sind." },
      { title: "Gewerbeversicherungen", desc: "Betriebshaftpflicht, Inhalts-, D&O- und Cyber-Schutz für Ihr Unternehmen." },
    ],
  },
  {
    key: "finanzierung",
    slug: "finanzierung",
    ogImage: "https://static.prod-images.emergentagent.com/jobs/9cdaf805-ebb2-4698-b869-6dae56934adb/images/b02942ccac4676418d1b2a2346825bcce508b4b4938b79c5d41f87ed2008157b.jpeg",
    icon: Landmark,
    title: "Finanzierung",
    kicker: "Kapital",
    tagline: "Ihr Weg zur optimalen Finanzierung.",
    keywords: "Baufinanzierung Frankfurt, Anschlussfinanzierung, Immobilienkredit, Ratenkredit, Zinsvergleich, Umschuldung",
    intro:
      "Ob Baufinanzierung, Anschlussfinanzierung oder Kredit – wir verhandeln für Sie mit über 400 Banken und Finanzierungspartnern. So sichern wir Ihnen nicht nur die besten Zinsen, sondern eine Struktur, die langfristig zu Ihrem Budget passt.",
    services: [
      { title: "Baufinanzierung", desc: "Solide, planbare Finanzierung für Kauf, Neubau oder Modernisierung." },
      { title: "Anschlussfinanzierung", desc: "Rechtzeitige Zinssicherung und Umschuldung für bestehende Darlehen." },
      { title: "Ratenkredite", desc: "Faire, flexible Konditionen für Anschaffungen und Wünsche." },
      { title: "Kapitalanlage-Finanzierung", desc: "Durchdachte Konzepte für renditestarke Immobilien-Investments." },
    ],
  },
  {
    key: "immobilien",
    slug: "immobilien",
    ogImage: "https://static.prod-images.emergentagent.com/jobs/9cdaf805-ebb2-4698-b869-6dae56934adb/images/3e9ea73796e193b55ddcf3fdeee745a56cc5bd7711ae40226430f69bb8bace8e.jpeg",
    icon: Building2,
    title: "Immobilien",
    kicker: "Werte",
    tagline: "Immobilien mit Weitblick.",
    keywords: "Immobilien Frankfurt, Immobilie verkaufen, Immobilienbewertung, Kapitalanlage Immobilie, Makler Rhein-Main",
    intro:
      "Vom Verkauf über die fundierte Bewertung bis zur Vermittlung begleiten wir Eigentümer und Käufer im Rhein-Main-Gebiet. Mit echter lokaler Marktkenntnis holen wir das Beste aus Ihrer Immobilie – diskret und professionell.",
    services: [
      { title: "Verkauf & Vermittlung", desc: "Professionelle Vermarktung mit maximaler Reichweite und Zielgruppenansprache." },
      { title: "Immobilienbewertung", desc: "Fundierte Marktwerteinschätzung nach aktuellen Bewertungsstandards." },
      { title: "Kaufberatung", desc: "Objektive Begleitung beim Erwerb Ihrer Wunschimmobilie." },
      { title: "Kapitalanlagen", desc: "Renditestarke Objekte für den nachhaltigen Vermögensaufbau." },
    ],
  },
];

export const AREA_OPTIONS = [
  { value: "versicherung", label: "Versicherungen" },
  { value: "finanzierung", label: "Finanzierung" },
  { value: "immobilien", label: "Immobilien" },
];
